// extracted by mini-css-extract-plugin
export default {"header":"U7knj2KJlF","section":"yKgiDsDZMQ"};